import { createReducer, on } from '@ngrx/store';
import { setTenantKey, clearTenantKey, updateTenantKey } from '../actions/tenant.actions';
import { TenantState, initialTenantState } from '../models/tenant.model';

export const tenantReducer = createReducer(
    initialTenantState,
    on(setTenantKey, (state, { tenantKey }) => {
        if (state.tenantKey === tenantKey) {
            return state; // Avoid unnecessary state updates
        }
        return { ...state, tenantKey }; // Correctly update tenantKey
    }),
    on(updateTenantKey, (state, { tenantKey }) => {
        if (state.tenantKey === tenantKey) {
            return state; // Avoid unnecessary state updates
        }
        return { ...state, tenantKey, isEncrypted: true }; // Update tenantKey and set isEncrypted to true
    }),
    on(clearTenantKey, () => ({ ...initialTenantState })),
);